import { defineRule, configure } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import ru from '@vee-validate/i18n/dist/locale/ru.json'
import i18n from '@/app/i18n'

// Check if the value is more than min limit
// Key for POEditor = "ValidationRules | gte_with_coin"
defineRule('gte_with_coin', (value, [input]) => +value >= +input)

// Check if the value is less than max limit
// Key for POEditor = "ValidationRules | lte_with_coin"
defineRule('lte_with_coin', (value, [input]) => +value <= +input)

// Check that balance is greater than min limit for the operation
// Key for POEditor = "ValidationRules | balance_limit"
defineRule(
  'balance_limit',
  (value, [min, balance]) => parseFloat(balance) >= parseFloat(min)
)

// Check that daily left limit is greater than min limit for the operation
// Key for POEditor = "ValidationRules | daily_left_limit"
defineRule(
  'daily_left_limit',
  (value, [minLimit, dailyLeft]) =>
    parseFloat(dailyLeft) >= parseFloat(minLimit)
)

const dictionary = {
  ru: {
    ...ru,
    messages: {
      ...ru.messages,
      gte_with_coin:
        "Минимально <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      lte_with_coin:
        "Максимально <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      balance_limit: 'Недостаточно средств',
      daily_left_limit: 'Превышен дневной лимит',
    },
  },
  en: {
    ...en,
    messages: {
      ...en.messages,
      gte_with_coin:
        "Minimum <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      lte_with_coin:
        "Maximum <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      balance_limit: 'Insufficient balance',
      daily_left_limit: 'Daily limit exceeded',
    },
  },
}

configure({
  generateMessage: localize(dictionary),
  classes: {
    valid: 'is-valid',
    invalid: ['is-invalid', 'error'],
  },
})

setLocale(i18n.global.locale.value)

if (i18n.global.locale) {
  const { watch } = require('vue')
  watch(
    () => i18n.global.locale.value,
    (newLocale) => {
      setLocale(newLocale)
    }
  )
}
